import PhishingPageList from 'components/branch/phishingPage/PhishingPageList';
import PhishingPageMenu from 'components/branch/phishingPage/PhishingPageMenu';
import MainTitle from 'components/common/admin/MainTitle';
import { useIntl } from 'react-intl';
import "./Conf.scss";

export default function Examtemplate(props: any) {
  const { formatMessage } = useIntl();
  

  return (
    <div className="admin-basic-conf table">
      <MainTitle type="table" title={formatMessage({ id: 'Phishing_1', defaultMessage: '피싱 페이지' })}>
        <PhishingPageMenu />
      </MainTitle>
      <div className="react-table-area">
        <PhishingPageList />
      </div>
    </div>
  );
}